// Archive links for news categories

const archiveLinkClick = (event) =>  {
    event.preventDefault();
    const targetUrl = '/nyheter/kategori/' + event.target.dataset.archiveLink;
    location.href = targetUrl;
}

const archiveLinks = document.querySelectorAll('[data-archive-link]');

[].slice.call(archiveLinks).forEach((archiveLink) => {
    archiveLink.addEventListener('click', archiveLinkClick);
});
